import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "absolute bottom-0 flex items-end justify-center px-4 pb-[63px] md:pl-6 md:pb-10 md:pr-[130px] xl:pl-[67px] xl:pb-[4.5rem] xl:pr-40" }
const _hoisted_3 = { class: "relative z-10 text-left" }
const _hoisted_4 = { class: "flex flex-wrap gap-2 mb-4 md:mb-8 xl:mb-[27px]" }
const _hoisted_5 = { class: "yeseva-one font-normal text-5xl leading-100p md:text-[64px] xl:text-8xl whitespace-pre-line mb-2 md:mb-4 xl:mb-2" }
const _hoisted_6 = { class: "sf-pro font-medium text-2xl leading-100p md:text-[32px] xl:text-[40px] whitespace-pre-line mb-4 md:mb-8 xl:mb-10" }
const _hoisted_7 = {
  key: 0,
  class: "sf-pro font-normal text-sm leading-[21px] md:text-base md:leading-[24px] xl:text-xl xl:leading-[28px] whitespace-pre-line"
}
const _hoisted_8 = { class: "text-gold" }
const _hoisted_9 = { class: "sf-pro font-normal text-sm leading-[21px] md:text-base md:leading-[24px] xl:text-xl xl:leading-[28px] whitespace-pre-line mb-4 md:mb-8 xl:mb-10" }
const _hoisted_10 = { class: "flex-1 text-left transition-colors duration-300 ease-in-out group-hover:text-active" }
const _hoisted_11 = { class: "ml-4 w-[46px] h-[46px] flex items-center justify-center rounded-full bg-white transition-colors duration-300 ease-in-out group-hover:bg-orange-gradient" }


import { NewsItem } from "@/types/news";
import { useI18n } from "vue-i18n";
import { useLangStore } from "@/stores/langStore";
import { formatDate } from "@/utils/date";
import ArrowIcon from "@/components/icons/ArrowIcon.vue";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'CarouselItem',
  props: {
    news: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const langStore = useLangStore();
const router = useRouter();

function openBlog() {
  router.push({
    name: ROUTE_NAMES.BLOG_DETAIL,
    params: { id: props.news.blog_id },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("section", {
        key: __props.news.background_url,
        class: "h-full flex flex-col text-white"
      }, [
        _createElementVNode("img", {
          src: __props.news.background_url,
          class: "absolute inset-0 w-full h-full object-cover",
          alt: "news background"
        }, null, 8, _hoisted_1),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.news.tags, (tag) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: tag.id,
                  class: "px-3 py-2 xl:px-4 xl:py-[10px] sf-pro font-normal text-base leading-100p md:text-xl bg-[#FFFFFF33] backdrop-blur-[20px]"
                }, _toDisplayString(tag.name), 1))
              }), 128))
            ]),
            _createElementVNode("p", _hoisted_5, _toDisplayString(__props.news.title), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(__props.news.subtitle), 1),
            (__props.news.start_education)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_unref(t)("carousel.start_education")) + " ", 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(formatDate)(__props.news.start_education, _unref(langStore).current)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_9, _toDisplayString(__props.news.short_description), 1),
            _createElementVNode("button", {
              class: "group relative flex items-center h-[56px] w-[225px] pl-6 pr-1 rounded-full border border-white text-white sf-pro-sm transition-colors duration-300 ease-in-out hover:bg-white",
              onClick: openBlog
            }, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)("carousel.show_more")), 1),
              _createElementVNode("span", _hoisted_11, [
                _createVNode(ArrowIcon, { class: "text-brown transition-transform duration-300 ease-in-out group-hover:text-white group-hover:rotate-45" })
              ])
            ])
          ])
        ])
      ]))
    ]),
    _: 1
  }))
}
}

})